var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvidenceTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "evidence-text-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "evidence-text-icon-group2",
    transform: "translate(-464.000000, -430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "evidence-text-icon-group3",
    transform: "translate(464.000000, 430.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "evidence-text-icon-rect1",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "evidence-text-icon-group4",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L32,8 L32,12 L0,12 L0,8 Z M0,20 L32,20 L32,16 L0,16 L0,20 Z M0,28 L16,28 L16,24 L0,24 L0,28 Z M0,0 L0,4 L32,4 L32,0 L0,0 Z",
    id: "evidence-text-icon-path1",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidenceTextIcon);
export default __webpack_public_path__ + "static/media/evidence-text-icon.f94d6b29.svg";
export { ForwardRef as ReactComponent };